<template>
  <boxwrap class="deposit-accounts--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="active"
            name="active"
          >
              <span>active</span>
          </select-option>

          <select-option
            value="inactive"
            name="inactive"
          >
              <span>inactive</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
              <span>deleted</span>
          </select-option>
        </select-list>

        <select-list
          class="toolbar-nav"
          :title="$route.params.type"
          v-model="selectedType"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="bank"
            name="bank"
          >
            <span>bank</span>
          </select-option>

          <select-option
            value="bitcoin"
            name="bitcoin"
          >
            <span>bitcoin</span>
          </select-option>

          <select-option
            value="ewallets"
            name="e-wallets"
          >
            <span>e-wallets</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>
        <button
          class="btn--delete"
          title="delete"
          @click="deleteData(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'inactive'"
        >
          <i class="ico--delete"></i>
        </button>
        <button
          class="btn--restore"
          title="restore"
          @click="restore(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'deleted'"
        >
          <i class="ico--restore"></i>
        </button>
        <button
          class="btn--modify"
          title="modify"
          @click="update(selected, depositAccounts)"
          v-if="selected.length > 0 &&
            $route.params.status !== 'deleted'"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{'data-loading': showDataLoading}"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      ></check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(depositAccounts)">
                </checkbox>
              </tbl-td>
              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="bank-name"
                :sort="true"
                @click.native="sort('bank_id')"
                v-if="checkCol('bank_id', tblSetting)"
              >
                bank name
              </tbl-td>

              <tbl-td
                name="bank-account"
                :sort="true"
                @click.native="sort('bank_account_name')"
                v-if="checkCol('bank_account_name', tblSetting)"
              >
                bank account name
              </tbl-td>

              <tbl-td
                name="bank-no"
                :sort="true"
                @click.native="sort('bank_number')"
                v-if="checkCol('bank_number', tblSetting)"
              >
                bank account no
              </tbl-td>

              <tbl-td
                name="bank-type"
                :sort="true"
                @click.native="sort('bank_type')"
                v-if="checkCol('bank_type', tblSetting)"
              >
                bank type
              </tbl-td>

              <tbl-td
                name="name"
                :sort="true"
                @click.native="sort('name')"
                v-if="checkCol('name', tblSetting)"
              >
                name
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="currency"
                :sort="true"
                @click.native="sort('currency_id')"
                v-if="checkCol('currency_id', tblSetting)"
              >
                currency
              </tbl-td>
              <tbl-td
                name="status"
                :sort="true"
                @click.native="sort('active')"
                v-if="checkCol('active', tblSetting)"
              >
                status
              </tbl-td>
              <tbl-td
                name="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              ></tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(account, index) in accountsData"
              :key="index"
              :class="[account.active === true ? '-active' : '-inactive', {'is-deleted': account.deleted_at}]"
              @click.native="showModifyPopUp(account)"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="account.id"
                  >
                </checkbox>
              </tbl-td>
              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ account.created_at | date }}
              </tbl-td>

              <tbl-td
                name="bank-name"
                v-if="checkCol('bank_id', tblSetting)"
              >
                {{ banks | filterBank(account.bank_id) }}
              </tbl-td>
              <tbl-td
                name="bank-account"
                v-if="checkCol('bank_account_name', tblSetting)"
              >
                {{ account.bank_account_name }}
              </tbl-td>
              <tbl-td
                name="bank-no"
                v-if="checkCol('bank_number', tblSetting)"
              >
                {{ account.bank_number }}
              </tbl-td>
              <tbl-td
                name="bank-type"
                v-if="checkCol('bank_type', tblSetting)"
              >
                {{ account.bank_type }}
              </tbl-td>
              <tbl-td
                name="name"
                v-if="checkCol('name', tblSetting)"
              >
                {{ account.name }}
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ account.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ account.deleted_at | date }}
              </tbl-td>
              <tbl-td
                name="currency"
                v-if="checkCol('currency_id', tblSetting)"
              >
                <select-list
                  :title="currency | filterCurrency(account.currency_id)"
                  :withReset="true"
                  v-model="account.currency_id"
                  v-if="checkPermission"
                  @reset="resetTrigger(account)"
                >
                  <select-option
                    v-for="(curr, idx) in currency"
                    :key="idx"
                    :value="curr.id"
                    :name="curr.name"
                    @click.native="setSelected(account)"
                  >
                    {{ curr.name }}
                  </select-option>
                </select-list>
                <span v-else>
                  {{ currency | filterCurrency(account.currency_id) }}
                </span>
              </tbl-td>
              <tbl-td
                name="status"
                v-if="checkCol('active', tblSetting)"
              >
                <select-list
                  :title="account.active === true ? 'active' : 'inactive'"
                  :withReset="true"
                  v-model="account.active"
                  v-if="checkPermission"
                  @reset="resetTrigger(account)"
                >
                  <select-option
                    :value="true"
                    name="active"
                    v-if="!account.active"
                    @click.native="setSelected(account)"
                  >
                    active
                  </select-option>
                  <select-option
                    :value="false"
                    name="inactive"
                    v-if="account.active"
                    @click.native="setSelected(account)"
                  >
                    inactive
                  </select-option>
                </select-list>
                <span v-else>
                  {{ account.active === true ? 'active' : 'inactive' }}
                </span>
              </tbl-td>
              <tbl-td
                class="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              >
                <button
                  class="btn--restore"
                  v-if="account.deleted_at"
                  @click.stop="restore(account.id)"
                >
                  <i class="ico--restore"></i>
                </button>
                <button
                  class="btn--delete"
                  v-else
                  @click.stop="deleteData(account.id)"
                >
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            v-model="params.page"
            :total="count"
            :limit="params.rows"
            :rows="params.rows"
            @page="trigger">
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-deposit"
      :title="'CREATE DEPOSIT ACCOUNT'"
      :activate="showCreate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showCreate"
      @activate="event => { showCreate = event,
        createParams = getDefaultModel() }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>deposit name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="createParams.name"
                >
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank type</span></div>
            <div class="form-data">
              <select-list
                :title="bankTypeTitle"
                :withReset="true"
                v-model="bankType"
              >
                <select-option
                  v-for="(type, idx) in bankTypes"
                  :key="idx"
                  :value="type.id"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank</span></div>
            <div class="form-data">
              <select-list
                :title="banks | filterBank(createParams.bank_id)"
                :withReset="true"
                v-model="createParams.bank_id"
                v-if="filteredBanks.length > 0"
              >
                <select-option
                  v-for="(bank, idx) in filteredBanks"
                  :key="idx"
                  :value="bank.id"
                  :name="bank.name"
                >
                  {{ bank.name }}
                </select-option>
              </select-list>
              <span v-else>No data</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="createParams.bank_account_name"
                >
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account no</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="createParams.bank_number"
                >
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>currency</span></div>
            <div class="form-data">
              <select-list
                :title="currency | filterCurrency(createParams.currency_id)"
                :withReset="true"
                v-model="createParams.currency_id"
              >
                <select-option
                  v-for="(curr, idx) in currency"
                  :key="idx"
                  :value="curr.id"
                  :name="curr.name"
                >
                  {{ curr.name }}
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-deposit"
      :title="'modify deposit account'"
      :activate="showUpdate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showUpdate"
      @activate="event => {
        showUpdate = event,
        hideModifyPopUp(updateParams)
      }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ updateParams.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>deposit name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="updateParams.name"
                >
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank type</span></div>
            <div class="form-data">
              <select-list
                :title="bankTypeTitle"
                :withReset="true"
                v-model="bankType"
              >
                <select-option
                  v-for="(type, idx) in bankTypes"
                  :key="idx"
                  :value="type.id"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank</span></div>
            <div class="form-data">
              <select-list
                :title="banks | filterBank(updateParams.bank_id)"
                :withReset="true"
                v-model="updateParams.bank_id"
                v-if="filteredBanks.length > 0"
              >
                <select-option
                  v-for="(bank, idx) in filteredBanks"
                  :key="idx"
                  :value="bank.id"
                  :name="bank.name"
                >
                  {{ bank.name }}
                </select-option>
              </select-list>
              <span v-else>No data</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="updateParams.bank_account_name"
                >
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>bank account no</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-model="updateParams.bank_number"
                >
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>currency</span></div>
            <div class="form-data">
              <select-list
                :title="currency | filterCurrency(updateParams.currency_id)"
                :withReset="true"
                v-model="updateParams.currency_id"
              >
                <select-option
                  v-for="(curr, idx) in currency"
                  :key="idx"
                  :value="curr.id"
                  :name="curr.name"
                >
                  {{ curr.name }}
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update(selected, depositAccounts, updateParams)"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  components: {
    Modal,
    Checkbox,
    Pagination,
    Search,
    CheckDataList
  },

  mixins: [ checkAll, getListStatus, swal ],

  filters: {
    filterBank (bankList, id) {
      let result

      bankList.forEach((data) => {
        if (data.id === id) {
          result = data.name
        }
      })
      return result
    },

    filterCurrency (currencyList, id) {
      let result

      currencyList.forEach((curr) => {
        if (curr.id === id) {
          result = curr.name
        }
      })
      return result
    }
  },

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      createParams: this.getDefaultModel(),
      filterBy: [
        {
          value: 'name',
          display: 'Name'
        },
        {
          value: 'bank_account_name',
          display: 'Bank Account Name'
        },
        {
          value: 'bank_number',
          display: 'Bank Account Number'
        },
        {
          value: 'bank_name',
          display: 'Bank Name'
        },
        {
          value: 'currency',
          display: 'Currency'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      updateParams: {},
      selected: [],
      selectAll: false,
      showCreate: false,
      showUpdate: false,
      accountsData: [],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      status: 'all',
      type: 'all',

      currency: [
        {
          id: 1,
          name: 'USD'
        },
        {
          id: 2,
          name: 'JPY'
        },
        {
          id: 3,
          name: 'KRW'
        }
      ],

      showTblSettings: false,
      tblSetting: 'deposit',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'bank name',
          value: 'bank_id'
        },
        {
          display: 'bank account name',
          value: 'bank_account_name'
        },
        {
          display: 'bank account no',
          value: 'bank_number'
        },
        {
          display: 'bank type',
          value: 'bank_type'
        },
        {
          display: 'name',
          value: 'name'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        },
        {
          display: 'currency',
          value: 'currency_id'
        },
        {
          display: 'status',
          value: 'active'
        }
      ],

      bankType: null,
      tmpBankId: null,
      tmpBankType: null
    }
  },

  computed: {
    ...mapState('deposit-account', [ 'depositAccounts', 'count' ]),
    ...mapState('bank', [ 'banks', 'bankTypes' ]),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    bankTypeTitle () {
      let data = this.bankTypes.find((row) => {
        return row.id === this.bankType
      })

      if (data !== undefined) {
        return data.name
      } else {
        return data
      }
    },

    filteredBanks () {
      let data = this.banks.map((row) => {
        return row.type_id === this.bankType ? row : null
      }).filter((row) => { return row !== null })

      return data
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    },

    bankType (val) {
      if (!val) {
        this.createParams.bank_id = ''
      }

      if (!this.tmpBankId && !this.tmpBankType && !val) {
        return
      }

      if (this.tmpBankType === val) {
        this.updateParams.bank_id = this.tmpBankId
      }

      if (this.tmpBankType !== val) {
        this.updateParams.bank_id = null
      }
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.params = this.generate(this.params)
    let bankParam = Object.assign({}, this.params, { rows: 'infinite' })
    this.search()
    await this.getBank({ status: 'active', params: bankParam })
  },

  methods: {
    ...mapActions('deposit-account',
      ['get', 'delete', 'recover']),
    ...mapActions('deposit-account', { updateDeposit: 'update' }),
    ...mapActions('deposit-account', { createDeposit: 'create' }),
    ...mapActions('bank', { getBank: 'get' }),

    getDefaultModel () {
      return {
        name: '',
        currency_id: '',
        bank_id: '',
        bank_account_name: '',
        bank_number: ''
      }
    },

    trigger (q) {
      let s = this.$route.params.status
      let t = this.$route.params.type
      this.params = q || this.params

      this.$router.push({ path: `/deposit-accounts/${s}/${t}`, query: this.params })
    },

    async search (q) {
      this.params = q || this.params
      this.status = this.$route.params.status
      this.type = this.$route.params.type

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        status: this.status,
        type: this.type,
        params: this.params
      })

      this.isDataLoading = false
      this.showDataLoading = false
      this.accountsData = JSON.parse(JSON.stringify(this.depositAccounts))

      if (!this.depositAccounts.length) {
        this.isEmpty = true
      }
    },

    async create () {
      let success = async () => {
        let result = await this.createDeposit(this.createParams)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created a deposit account.', {}, '', 'Success')
          this.createParams = this.getDefaultModel()
          this.showCreate = false
          this.search()
        }
      }

      if (this.createParams.name.trim() === '' || this.createParams.bank_account_name.trim() === '' ||
          this.createParams.bank_number === '' || this.createParams.bank_id === '' ||
          this.createParams.currency_id === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Desposit Account')
    },

    async update (selected, accounts, account) {
      let success = async () => {
        let params = []
        let result

        if (!account) {
          accounts.forEach((data) => {
            selected.forEach((v, k) => {
              if (data.id === v) {
                params.push(Object.assign({}, data,
                  {
                    created_at: undefined,
                    deleted_at: undefined,
                    updated_at: undefined,
                    active: data.active === 'true' ? 1 : 0
                  })
                )
              }
            })
          })
        } else {
          params.push(Object.assign({}, account,
            {
              created_at: undefined,
              deleted_at: undefined,
              updated_at: undefined,
              active: account.active === 'true' ? 1 : 0
            })
          )
        }

        result = await this.updateDeposit(params)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully modified the deposit account(s).', {}, '', 'Success')
          this.search()
          this.resetParams('update')
        }
      }

      if (account && (account.name.trim() === '' || account.bank_account_name.trim() === '' ||
          account.bank_number.trim() === '' || account.bank_id === null ||
          account.currency_id === null)) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify the following deposit account(s)?',
        {}, { success }, 'Modify Deposit Account')
    },

    async deleteData (ids) {
      let success = async () => {
        let params = []
        let result

        if (!Array.isArray(ids)) {
          params.push(ids)
        } else {
          params = ids
        }

        result = await this.delete(params)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully removed the deposit account(s).', {}, '', 'Success')
          this.search()
          this.resetParams()
        }
      }

      this.$alert('prompt', 'Are you sure you want to remove deposit account(s)?', {}, { success }, 'Remove Desposit Account')
    },

    async restore (ids) {
      let success = async () => {
        let params = []
        let result

        if (!Array.isArray(ids)) {
          params.push({
            id: ids,
            data: { deleted_at: null }
          })
        } else {
          ids.map((id) => {
            params.push({
              id: id,
              data: { deleted_at: null }
            })
          })
        }

        result = await this.recover(params)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully restored the deposit account(s).', {}, '', 'Success')
          this.search()
          this.resetParams()
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore deposit account(s)?', {}, { success }, 'Restore Desposit Account')
    },

    resetParams (data = null) {
      if (data === 'filter') {
        this.params = {
          page: 1,
          rows: 50,
          filter_by: '',
          q: '',
          sort_by: 'id',
          sort: 'desc',
          date_from: '',
          date_to: ''
        }
      }

      if (data === 'update') {
        this.updateParams = {}
        this.showUpdate = false
      }

      this.selected = []
      this.selectAll = false
    },

    setSelected (account) {
      this.$nextTick(() => {
        let result = this.depositAccounts.find((row) => {
          return row.id === account.id
        })

        let idx = this.selected.indexOf(account.id)

        if (account.currency_id === result.currency_id &&
            account.active === result.active &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (account.currency_id === result.currency_id &&
          account.active === result.active) {
          return
        }

        this.selected.push(account.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    showModifyPopUp (account) {
      if (this.checkPermission) {
        this.selected.push(account.id)
        this.showUpdate = true
        this.updateParams = Object.assign({}, account)

        let data = this.bankTypes.find((row) => {
          return row.name.toLowerCase() === this.updateParams.bank_type.toLowerCase()
        })

        this.bankType = data.id
        this.tmpBankType = data.id
        this.tmpBankId = this.updateParams.bank_id
      }
    },

    hideModifyPopUp (data) {
      let idx = this.selected.indexOf(data.id)

      this.selected.splice(idx, 1)
    },

    resetTrigger (account) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(account.id)

        let result = this.depositAccounts.find((row) => {
          return row.id === account.id
        })

        if (result.currency_id !== account.currency_id) {
          count += 1
        }

        if (result.active !== account.active) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    }
  }
}
</script>
